import { isEmpty, hasOwnProperty, uniqueKey } from "@/lib/utils";
import store from "@/store";

const VueSchoolmom = {};
const requireComponent = require.context("./", false, /Pb[A-Z]\w+\.(vue)$/);

VueSchoolmom.install = function(Vue) {
  // install component
  requireComponent.keys().forEach((fileName) => {
    const componentConfig = requireComponent(fileName);
    const componentName = /^\.\/([A-Z]\w+)\.vue$/.exec(fileName)[1];

    Vue.component(componentName, componentConfig.default || componentConfig);
  });

  /**
   * * pb-confirm
   * * $confirm chain to base of store
   */
  if (!Vue.prototype.$confirm) {
    Vue.prototype.$confirm = {};

    Vue.prototype.$confirm.show = function(confirmValue) {
      if (!isEmpty(confirmValue) && hasOwnProperty(confirmValue, "title")) {
        store.commit("SHOW_CONFIRM", confirmValue);
      }
    };

    Vue.prototype.$confirm.hide = function() {
      store.commit("HIDE_CONFIRM");
    };
  }

  if (!Vue.prototype.$alert) {
    Vue.prototype.$alert = {};

    Vue.prototype.$alert.options = {
      duration: 3000,
      position: "BOTTOM_RIGHT",
      space: 16,
    };

    Vue.prototype.$alert.show = function({ type, content }) {
      const uid = uniqueKey();

      store.commit("ADD_ALERTS", {
        uid,
        type,
        content,
        close: () => this.remove(uid),
      });

      setTimeout(() => {
        this.remove(uid);
      }, this.options.duration);
    };

    Vue.prototype.$alert.remove = function(uid) {
      store.commit("REMOVE_ALERTS", uid);
    };

    Vue.prototype.$alert.success = function(content) {
      this.show({ type: "success", content });
    };

    Vue.prototype.$alert.error = function(content) {
      this.show({ type: "error", content });
    };

    Vue.prototype.$alert.info = function(content) {
      this.show({ type: "info", content });
    };

    Vue.prototype.$alert.warning = function(content) {
      this.show({ type: "warning", content });
    };
  }

  //   Vue.mixin({
  //     data: () => ({
  //       /**
  //        * * alerts Item Type
  //        *
  //        * {
  //        *  uid: uniqueKey<String>,
  //        *  type: success | error | warning | info
  //        *  content: String
  //        * }
  //        */
  //       alerts: [],
  //       alertOption: {
  //         duration: 1500,
  //         position: "BOTTOM_RIGHT",
  //         close: true
  //       }
  //     }),
  //     computed: {
  //       $alert() {
  //         return {
  //           success: content => {
  //             this.message({
  //               type: "success",
  //               content
  //             });
  //           },
  //           error: content => {
  //             this.message({
  //               type: "error",
  //               content
  //             });
  //           },
  //           info: content => {
  //             this.message({
  //               type: "info",
  //               content
  //             });
  //           },
  //           warning: content => {
  //             this.message({
  //               type: "warning",
  //               content
  //             });
  //           }
  //         };
  //       },

  //       $alertOption: {
  //         get() {
  //           return this.alertOption;
  //         },
  //         set(val) {
  //           this.alertOption = { ...this.alertOption, ...val };
  //         }
  //       }
  //     },
  //     methods: {
  //       remove(uid) {
  //         console.log("remove");
  //       },
  //       message({ type, content }) {}
  //     }
  //   });
};

export default VueSchoolmom;
